import Domains from '../../constants/Domains';
import Site from '../interfaces/site';

export const getPrimaryPage = (site: Site) => site && site.pages && site.pages.find(p => p.default);
export const buildCanonicalLink = (page: any = {}, site?: Site) => {
  if (!site) return;
  const { pages, key } = site;
  const prefix = `${Domains.HIPAGES_URL}/connect/${key}`;

  // default Flag is in the page collection of site - we need to compare through there
  const pageFromSite = pages.find(pageInSite => pageInSite.id === page.id);
  if (pageFromSite && !pageFromSite.default) {
    return `${prefix}/${page.tab_key}/${page.entity_key}`;
  }

  return prefix;
};

const blankCategory = {
  seo_key: null,
  name: null,
  roll_up: null,
  parent_seo_key: null
};

const blankLocation = {
  state_code: null,
  capital_city: null,
  capital_city_seo_key: null,
  suburb: null,
  suburb_seo_key: null
};

export const getProfileBreadcrumbs = (site: Site) => {
  if (!site) return [];

  const { primary_category = blankCategory, primary_location } = site;
  const {
    seo_key: categoryKey,
    name: categoryName,
    roll_up: isRollUp,
    parent_seo_key: parentSeoKey
  } = primary_category || blankCategory;
  const {
    state_code: state,
    capital_city: cityName,
    capital_city_seo_key: citySeoKey,
    suburb: suburbName,
    suburb_seo_key: suburbKey
  } = primary_location || blankLocation;

  const categoryRollUp = isRollUp ? parentSeoKey : categoryKey;
  const cityKey = citySeoKey && citySeoKey !== suburbKey ? citySeoKey : null;

  const breadcrumbs = [
    { preqrequisites: [], href: '/', name: 'hipages' },
    { preqrequisites: [categoryRollUp], name: categoryName },
    { preqrequisites: [categoryRollUp, state], name: state },
    { preqrequisites: [categoryRollUp, state, cityKey], name: cityName },
    { preqrequisites: [categoryRollUp, state, suburbKey], name: suburbName },
    { preqrequisites: [], href: `/connect/${site.key}`, name: site.name }
  ];

  const filteredBreadcrumbs = breadcrumbs.filter(breadcrumb =>
    breadcrumb.preqrequisites.every(condition => !!condition)
  );

  return filteredBreadcrumbs.map(({ preqrequisites, href, name }) => {
    const fullHref = typeof href !== 'undefined' ? href : `/find/${preqrequisites.join('/')}`;
    return { name, href: fullHref ? fullHref.toLowerCase() : null };
  });
};
